<ng-content></ng-content>

<ng-container *ngFor="let item of projectFilters">

    <ng-container
        [ngTemplateOutlet]="filterProjectItemTemplateRef"
        [ngTemplateOutletContext]="{ $implicit: item }"
    ></ng-container>

</ng-container>
